import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from 'src/shared/components/form/Select';
import renderMultiSelectField from 'src/shared/components/form/MultiSelect';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const TerritoryModalAddOrUpdate = ({ handleSubmit }) => {

    useEffect(() => {
        getAllEmiratesDetails();
    }, []);
   
    const [isAreaWiseList, setAreaWiseList] = useState([]);
    const [isStateList, setateList] = useState([]);
    const getAllEmiratesDetails = async () => {
        let stateList = [];
        try {
       
            const response = await PndRestApi.GetAllEmiratesDetails();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.map(item => {
                    stateList.push({ "label": item.stateName, "value": item.stateCode });
                })
                setateList(stateList);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data?.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }

    };
    const getAreas = async (event) => {
        let areaListArray = [];
        if (event.value) {
            try {
         
                const response = await PndRestApi.GetStateWiseAreas(event.value);
                if (response.status === 200 && response.data.status === 200) {
                    response.data.data.map(item => {
                        areaListArray.push({ "label": item.territoryName, "value": item.territoryAreaId });
                    })

                    setAreaWiseList(areaListArray);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response.data.status}`,
                        `Message:${response.data?.message}`,
                    );
                    return;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    ERROR_MESSAGES.tryCatchError,
                );
            } 
        } else {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 204`,
                `Message: No Data Found`,
            );
        }
    };
    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Col lg={12} md={12}>
                <Row>

                    <Col lg={4} md={4}>

                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Territory Name</span>
                            <div className="form__form-group-field">
                                <Field name="regionName" component={renderField} type="text" placeholder="Region Name" validate={[required]} disabled={true} />

                            </div>
                        </div>
                    </Col>


                    <Col lg={4} md={4}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Territory Code</span>
                            <div className="form__form-group-field">
                                <Field name="regionCode" component={renderField} type="text" placeholder="Region Code" validate={[required]} disabled={true} />
                            </div>
                        </div>
                    </Col>


                    <Col lg={4} md={4}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Emirates</span>
                            <div className="form__form-animated-group-field">
                                <Field
                                    validate={[required]}
                                    name="stateInfo"
                                    component={renderSelectField}
                                    type="text"

                                    options={isStateList}
                                    label="emirates"
                                    placeholder="Select Emirates"
                                    onChange={event => {
                                        getAreas(event)
                                    }}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col lg={12} md={12}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span><span className="form__form-animated-group-label">Areas</span>
                            <div className="form__form-animated-group-field">
                                <Field
                                    validate={[required]}
                                    name="areaInfo"
                                    component={renderMultiSelectField}
                                    type="text"
                                    options={isAreaWiseList}
                                    label="areaInfo"
                                    placeholder="Select Areas to include in this Territory "

                                />
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* <Row>
                    <Col lg={4} md={4}>
                        <div className="form__form-animated-group">
                            <div className="form__form-group">
                                <span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Status</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row> */}
            </Col>

            <div className="form__OnboardingButton">
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                </ButtonToolbar>
            </div>

        </form>

    );
};


TerritoryModalAddOrUpdate.propTypes = {
    TerritoryModalAddOrUpdate: PropTypes.func.isRequired,
};


const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                regionCode: data?.dataInfo[0]?.regionInfo?.regionCode,
                regionName: data?.dataInfo[0]?.regionInfo?.regionName,
                regionId: data?.dataInfo[0]?.regionInfo?.regionId,

            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'TerritoryModalAddOrUpdateForm', enableReinitialize: true })(TerritoryModalAddOrUpdate))